import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {Observable, of, switchMap, tap} from 'rxjs';
import { AuthorizationServiceProvider } from 'src/app/auth_profile/services/authorization-service.provider';
import {LogsService} from "../../utils/services/logs.service";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SchoolGuardService {

  private schoolId
  constructor(private authService: AuthorizationServiceProvider,
              private router: Router,
              private logger: LogsService) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const schoolId = route.data['schoolId'] || null
    const routePath = route.routeConfig?.path ?? '<unknown>';
    this.logger.log(`[SchoolGuard] start route=${routePath} expectedSchoolId=${schoolId}`);
    const routeSchoolIdParam = route.paramMap.get('schoolId')
    const routeSchoolId = routeSchoolIdParam ? +routeSchoolIdParam : null
    if (schoolId != null && routeSchoolId != null && routeSchoolId !== schoolId) {
      this.router.navigateByUrl('/forbidden').then()
      return of(false)
    }
    return this.getSchoolId().pipe(
      switchMap(_ => {
        // for callanonline students
        if(this.schoolId === 1)
          if(schoolId === 1 && environment.colFunctionality) {
            this.logger.log(`[SchoolGuard] allow schoolId=${this.schoolId} route=${routePath}`);
            return of(true)
          } else {
            this.logger.log(`[SchoolGuard] deny schoolId=${this.schoolId} expected=${schoolId} colFunctionality=${environment.colFunctionality} route=${routePath} -> /forbidden`);
            this.router.navigateByUrl('/forbidden').then()
          }
        // for other students
        else if(this.schoolId !== 1)
          if(schoolId !== 1) {
            this.logger.log(`[SchoolGuard] allow schoolId=${this.schoolId} route=${routePath}`);
            return of(true)
          } else {
            this.logger.log(`[SchoolGuard] deny schoolId=${this.schoolId} expected=${schoolId} route=${routePath} -> /forbidden`);
            this.router.navigateByUrl('/forbidden').then()
          }
        return of(false)
      })
    )
  }

  private getSchoolId(): Observable<Number> {
    if(this.schoolId)
      return of(this.schoolId)
    else
      return this.authService.getAuthDetailsService().pipe(
        switchMap(authDetailsApi => authDetailsApi.getSelfSchoolId()),
        tap(schoolId => {
          this.schoolId = schoolId
          this.logger.log(`[SchoolGuard] resolved userSchoolId=${this.schoolId}`)
        })
      )
  }
}
